import React, { useState, useEffect } from 'react';
import Accordian from '../../common/components/Accordian/Accordian.js'
import logo from "../../common/media/cc_logo_white.svg";
import { formatNumber } from "../../common/util/numberFormatter";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

import { projects as getProjects } from '../../common/api/projects'
import ProjectsList from "./../Projects/ProjectsList";
import Popover from "../../common/components/popover/popover.js";
import { footerLinks } from '../../common/util/uiConfigs/footerConfiguration.js';
import logoGrey from '../../common/media/cc_logo_grey.svg';

const LandingPage = ({ merchantCode, fetchedImpact }) => {
    const [projects, setProjects] = useState();
    
    const numberOfWineGlasses = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.impactProgress?.wineGlasses?.currentCount);
    const carbonOffsetImpact = fetchedImpact && !fetchedImpact.error && formatNumber(Math.round(fetchedImpact.impactProgress?.carbonOffset?.currentCount));
    const carbonOffsetImpactUnit = fetchedImpact && !fetchedImpact.error && fetchedImpact.carbonOffsetImpact?.unit.toLowerCase()
    const treeGrowthYears = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.impactProgress?.treeGrowthYears?.currentCount);
    
    const treeMetric = treeGrowthYears && <span className="translate-dynamic"><span>An average tree captures about 20kg of carbon dioxide per year, and about 1 tonne over its lifetime. By funding projects that offset carbon emissions, we are having the same impact as</span> <span className="no-translate"> {treeGrowthYears}</span> <span>trees have in one year.</span></span>
        
    useEffect(() => {
        getProjects(null, merchantCode)
            .then(response => response.json())
            .then(data => setProjects(data))
            .catch(setProjects);

    }, []);

    return (
        <div>
            {/* <div className="transparent-header">
                <div className="container">
                    
                </div>
            </div> */}
            <div className="h-85vh w-100 img-cover hero-img" >
                <div className="container color-white text-align-start vertical-align h-100">
                    <div className="tab-show mobile-logo pt-3">
                        <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1629459033/Enterprise/Good-grape/good-grape-logo_tcnvdv.svg`} style={{ height: '158px' }} />
                    </div>
                    <div className="row h-100 mb-responsive">
                        <div className="col-xl-7">
                            <div className="content-vertical-justify">
                                <div className="tab-hide">
                                    <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1629459033/Enterprise/Good-grape/good-grape-logo_tcnvdv.svg`} style={{ height: '158px' }} />
                                </div>
                                <div className="mw-731px">
                                    <h1 className="text-shadow mt-0 text-secondary">There’s good wine, and then there is wine that’s truly good.</h1>
                                </div>

                                <div className="d-flex mobile-hide mb-jus-center">
                                    <p className="mr-2 mt-0 text-secondary">Powered by</p>
                                    <div>
                                        <a className="text-secondary" target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 18 }} src={logoGrey} alt="Carbonclick logo" /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-5">
                            <img className="bottleImg" src={`https://res.cloudinary.com/carbonclick/image/upload/v1629694141/Enterprise/Good-grape/Group_4537_jfiqoa.png`} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="mobile-show mb-border">
                <div className="bg-primary p-3 text-center">
                    <div className="d-flex w-fit center color-white">
                        <p className="mr-2 font-bold mt-0 mb-0">Powered by</p>
                        <div>
                            <a className="d-flex" target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 26 }} src={logo} /></a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-icon-section bg-pink">
                <div className="pt-3 text-center">
                    <div className="container">
                        <div className="mw-800px center">
                            <img className="mb-w-50" src={`https://res.cloudinary.com/carbonclick/image/upload/v1629692785/Enterprise/Good-grape/image_96_f4g3oi.svg`} />
                            <h2 className="text-secondary py-3 m-0">The Good Grape is so good for<br /> the climate, it’s Climate Positive. </h2>
                            <p className="m-0 lrg text-light">We’ve partnered with CarbonClick to double offset the estimated emissions for each bottle of the Good Grape range, by supporting native forest regeneration projects in New Zealand and Australia and clean energy projects in India.</p>
                        </div>
                    </div>
                </div>
                <div className="py-140">
                    <div className="container text-center">
                        <div className="mb-4 pb-3 center mb-mar-0">
                            <h2 className="font-bold text-secondary mb-3 mt-0">Our Positive Impact</h2>
                        </div>
                        <div className="tab-hide">
                            <div>
                                <div className="row text-align-start justify-content-center">

                                    <div className="col-md-auto d-grid">
                                        <div className="center w-100">
                                            <div className="img-cover img-1 w-100">
                                                <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1629692781/Enterprise/Good-grape/Group_571_ovtiti.jpg`}/>
                                            </div>
                                            <div className="font-bold">
                                                <h2 className="count-title text-primary mb-2">{numberOfWineGlasses}</h2>
                                                <p className="text-grey mdm mt-0">Glasses made Climate Positive</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-auto d-grid">
                                        <div className="center w-100">
                                            <div className="img-cover img-1 w-100">
                                                <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1629692782/Enterprise/Good-grape/Group_572_lphahk.jpg`} />
                                            </div>
                                            <div className="font-bold">
                                                <h2 className="count-title text-primary mb-2">{carbonOffsetImpact}</h2>
                                                <p className="text-grey mdm mt-0">{carbonOffsetImpactUnit} of CO2 Offset</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-auto d-grid">
                                        <div className="center w-100">
                                            <div className="img-cover img-1 w-100">
                                                <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1629692782/Enterprise/Good-grape/Group_573_e8s2ol.jpg`} />
                                            </div>
                                            <div className="font-bold">
                                                <h2 className="count-title text-primary mb-2">{treeGrowthYears}</h2>
                                                <p className="text-grey mdm mt-0"><span className="mr-2">Tree Growth Years</span>
                                                    <Popover content={treeMetric} >
                                                        <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
                                                            <path d="M0 0h24v24H0z" fill="none" />
                                                            <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
                                                        </svg>
                                                    </Popover>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="tab-show text-center">
                        <div className="container">
                            <Carousel dynamicHeight={false} showThumbs={false} showArrows={false} showStatus={false} infiniteLoop={true} autoPlay={true}>
                                <div key="1">
                                    <div className="center w-100">
                                        <div className="img-cover img-1 w-100">
                                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1629692781/Enterprise/Good-grape/Group_571_ovtiti.jpg`} />
                                        </div>
                                        <div className="font-bold">
                                            <h2 className="count-title text-primary mb-2">{numberOfWineGlasses}</h2>
                                            <p className="text-grey mdm mt-0">Glasses made Climate Positive</p>
                                        </div>
                                    </div>
                                </div>

                                <div key="2">
                                    <div className="center w-100">
                                        <div className="img-cover img-1 w-100">
                                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1629692782/Enterprise/Good-grape/Group_572_lphahk.jpg`} />
                                        </div>
                                        <div className="font-bold">
                                            <h2 className="count-title text-primary mb-2">{carbonOffsetImpact}</h2>
                                            <p className="text-grey mdm mt-0">{carbonOffsetImpactUnit} of CO2 Offset</p>
                                        </div>
                                    </div>
                                </div>

                                <div key="3">
                                    <div className="center w-100">
                                        <div className="img-cover img-1 w-100">
                                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1629692782/Enterprise/Good-grape/Group_573_e8s2ol.jpg`} />
                                        </div>
                                        <div className="font-bold">
                                            <h2 className="count-title text-primary mb-2">{treeGrowthYears}</h2>
                                            <p className="text-grey mdm mt-0"><span className="mr-2">Tree Growth Years</span>
                                                <Popover content={treeMetric} >
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
                                                        <path d="M0 0h24v24H0z" fill="none" />
                                                        <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
                                                    </svg>
                                                </Popover>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </Carousel>
                        </div>
                    </div>
                </div>
            </div>
            
            {Array.isArray(projects) && (
            <div className="py-100 bg-primary project-section">
                <div className="container text-center">
                    <div className="mb-4 pb-3 center mb-mar-0">
                        <h2 className="font-bold mb-3">Support Projects That Fight Climate Change</h2>
                        <p className="mdm mw-800px center" style={{ fontSize: 14 }}>We support only the highest quality carbon offsetting projects around the<br/> world, to bring you peace of mind and results.</p>
                    </div>
                    <ProjectsList title={null} projects={projects} />
                </div>
            </div>
            )}

            <div className="py-100 bg-grey pb-0">
                <div className="container text-center">
                    <div className="mb-4 pb-3 center">
                        <h2 className="font-bold mb-3">Sustainability is more than just the environment...</h2>
                        <p className="mdm mw-800px center text-light">We’ve always believed in making wine that’s for the people, and by expanding this belief beyond the bottle we’ve made wines that are good for the people in more ways than one. </p>
                    </div>
                    <div className="row justify-content-between center">
                        <div className="col-lg-4 col-md-5 px-lg-0">
                                <h4 className="text-secondary">Environment: Good for the planet</h4>
                            <p className="text-light">We offset almost twice our footprint<br className="tab-hide" /> through local and global green initiatives<br className="tab-hide" /> like reforestation projects in New Zealand<br className="tab-hide" /> and Australia.</p>
                        </div>
                        <div className="col-lg-4 col-md-5">
                            <h4 className="text-secondary">Social: Good for the People</h4>
                            <p className="text-light">We’ll invest $100k annually across Australia and New Zealand to support communities in need. In Australia we will be working with OZ Harvest to support people in need.</p>
                        </div>
                        <div className="col-md-12">
                            <img className="mt-4" src={`https://res.cloudinary.com/carbonclick/image/upload/v1629692784/Enterprise/Good-grape/Group_4528_uiwdtv.png`}/>
                        </div>
                    </div>
                </div>
            </div>

            <div className="py-100 bg-pink pb-0">
                <div className="container text-center">
                    <div className="mb-4 pb-3 center">
                        <h2 className="font-bold mb-3">What is Climate Positive and how does it work?</h2>
                        <p className="mdm mw-800px center text-light">Good Grape have partnered with CarbonClick to make a great wine that is also good for the environment. By going Climate Positive, we are offsetting <b>twice</b> the estimated carbon footprint of each bottle, meaning each bottle has a <b>positive impact</b> on the environment. </p>
                        <p className="mdm mw-800px center text-light">Carbon offsetting is the process of balancing out carbon emissions by buying carbon credits. The estimated footprint of our wine is around 2.5kg of CO₂e, meaning we buy 5kg of CO₂e per bottle from a mix of New Zealand and Australia native reforestation and international clean energy projects. </p>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-12">
                            <img className="mt-4" src={`https://res.cloudinary.com/carbonclick/image/upload/v1629692782/Enterprise/Good-grape/Group_4536_mjd64x.png`} />
                        </div>
                        <div className="col-md-8 text-left mt-4">
                            <div className="row justify-content-center">
                                <div className="col-md-auto">
                                    <b className="text-light">Sources:</b>
                                </div>
                                <div className="col-md-auto">
                                    <p className="m-0 text-light xsml mb-break">1/ https://mro.massey.ac.nz/bitstream/handle/10179/2920/02_whole.pdfTBC</p>
                                    <p className="m-0 text-light xsml mb-break">2/ https://www.mdpi.com/2071-1050/11/10/2945/htm</p>
                                    <p className="m-0 text-light xsml mb-break">3/ https://www.aidic.it/cet/14/39/100.pdf</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="py-100 bg-pink">
                <div className="container text-center">
                    <h2 className="font-bold text-secondary mt-0">Climate Friendly FAQs</h2>
                    <div className="mb-4 center text-align-start mw-800px mt-4">
                        <Accordian title={"What are carbon credits?"} >A carbon credit is mechanism used to measure and support projects that fight climate change. For every tonne of CO2 that a project manages to absorb or otherwise reduce, a carbon credit is issued. Carbon credits are certified by international standards and held in registries like the Gold Standard registry (international credits) and can be purchased to reduce the carbon impact of an initiative or activity.</Accordian>
                        <Accordian title={"What does Climate Positive mean?"} >Climate Positive means that every bottle of the Good Grape is having a positive impact on our climate. This is because the carbon footprint of each bottle is being double offset, meaning its own environmental impact is neutralised two times over, resulting in a net positive contribution to the environment.</Accordian>
                        <Accordian title={"Who are CarbonClick?"} >CarbonClick is a New Zealand company that exists to reverse climate change by empowering businesses and their customers to take climate action. By making carbon offsets simple, trustworthy and cost effective, CarbonClick is connecting millions of people to high quality offsetting projects that restore nature and reduce pollution, building a happier and more sustainable future for everyone.</Accordian>
                        <Accordian title={"Where does the money go?"} >The money paid to CarbonClick for carbon credits goes towards certified carbon offset projects that have met the highest standards. The funds are distributed amongst carbon offset suppliers carrying out the projects and CarbonClick takes a margin on the carbon credits for sourcing projects, quality assurance, administration and transaction fees.</Accordian>
                    </div>
                    <a href={footerLinks.faq} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-lg font-bold" >View All <img className="ml-2" src={`https://res.cloudinary.com/carbonclick/image/upload/v1629708738/Enterprise/Good-grape/chevron-double-right_usz0tl.svg`} /></a>
                </div>
            </div>

            <div className="w-100 img-cover footer-img py-6" >
                <div className="container color-white py-5">
                    <p><b>Powered by</b></p>
                    <div className="d-flex">
                        <div>
                            <a href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">
                                <img style={{ height: 30 }} className="footer-logo" src={logo} alt="carbonclick" />
                            </a>
                        </div>
                        <div className="right">
                            <div className="text-md-right">
                                <p style={{ fontSize: 14 }}>Previously offset a flight?</p>
                                <p style={{ fontSize: 14 }}>Log in to <a className="text-white text-underline" href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">My CarbonClick</a> to see the impact</p>
                            </div>
                        </div>
                    </div>
                    <hr className="mb-4" />

                    <div className="row justify-content-between bullet-point">
                        <div className="col-md">
                            <div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">How it works</a></div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.aboutCarbonClick} target="_blank" rel="noopener noreferrer">About CarbonClick</a></div>
                            </div>
                        </div>
                        <div className="col-md">
                            <div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.termsAndConditions} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy policy</a></div>
                            </div>
                        </div>
                        <div className="col-md">
                            <div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.contactUs} target="_blank" rel="noopener noreferrer">Contact us</a></div>
                                <div className="mb-3"><a className="color-white" href="mailto:support@carbonclick.com" target="_blank" rel="noopener noreferrer">support@carbonclick.com</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default LandingPage;